export enum RuntimePermissionStatus {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
}

export interface RuntimeModulePermissions {
  roles: Array<number>;
  status: RuntimePermissionStatus;
  permissions: Array<string>;
}

export interface PermissionsRuntimeState {
  modules: Record<string, RuntimeModulePermissions>;
  initialized: boolean;
  loading: boolean;
}
